import i18next from 'i18next';

const BILINGUAL_SEPARATOR = ' · ';

function prefersPolish(): boolean {
  const language = i18next.language;
  return typeof language === 'string' && language.toLowerCase().startsWith('pl');
}

export function resolveLocalizedName(nameEn: string, namePl: string): string {
  if (prefersPolish()) {
    return namePl.length > 0 ? namePl : nameEn;
  }
  return nameEn.length > 0 ? nameEn : namePl;
}

export function resolveOtherLanguageName(nameEn: string, namePl: string): string {
  const otherName = prefersPolish() ? nameEn : namePl;
  return otherName === resolveLocalizedName(nameEn, namePl) ? '' : otherName;
}

export function formatBilingualName(nameEn: string, namePl: string): string {
  const otherName = resolveOtherLanguageName(nameEn, namePl);
  const primaryName = resolveLocalizedName(nameEn, namePl);
  return otherName.length === 0 ? primaryName : primaryName + BILINGUAL_SEPARATOR + otherName;
}
